import React from "react";
import { CarDetails, InfoModal, PageLayout } from "../../components";
import { VehicleVariantCard } from "../../components/VehicleVariantCard/VehicleVariantCard";
import { capitaliseFirstLetters } from "../helpers";

interface IVehicleVariantProps {
  bodyTypesToFilter: string[];
  closeModal: VoidFunction;
  filteredVariants: IMultiMatch[];
  handleSelectClick: VoidFunction;
  onChangeBodyType: (arg: string) => void;
  openModal: VoidFunction;
  selectedBodyType: string | undefined;
  showFilter: boolean;
  showModal: boolean;
  showVariants: boolean;
  vehicle: IVehicle;
}

export default function VehicleVariant({
  bodyTypesToFilter,
  closeModal,
  filteredVariants,
  handleSelectClick,
  onChangeBodyType,
  openModal,
  selectedBodyType,
  showFilter,
  showModal,
  showVariants,
  vehicle
}: IVehicleVariantProps) {
  return (
    <div>
      <PageLayout>
        <PageLayout.Header title="Vehicle details" step={1} />
        <PageLayout.Content backgroundColour={null}>
          <>
            <p className="ch-fs--4 ch-mb--1">Confirm your vehicle details</p>
            <div
              className="ch-display--flex ch-align-items--start"
              onClick={openModal}
            >
              <div className="icon__info"></div>
              <p className="variant-modal-anchor ch-pl--1">Vehicle details</p>
            </div>

            <CarDetails
              manufacturer={vehicle.manufacturer}
              model={vehicle.model}
              registration={vehicle.registration}
              styles="ch-bg--white"
            />

            {showFilter && (
              <>
                <label
                  htmlFor="variant-filter"
                  className="ch-fs--3 ch-form__control-label"
                >
                  Select your body type
                </label>
                <div className="ch-form__group variant-dropdown">
                  <select
                    className="ch-form__control ch-width--12"
                    data-testid="variant-filter"
                    defaultValue=""
                    id="variant-filter"
                    name="variant-filter"
                    onChange={(event) => onChangeBodyType(event.target.value)}
                    required
                    value={selectedBodyType}
                  >
                    <option value="" disabled>
                      Please select
                    </option>
                    {bodyTypesToFilter.map((bodyType) => (
                      <option
                        data-testid="bodywork-option"
                        key={bodyType}
                        value={bodyType}
                      >
                        {bodyType}
                      </option>
                    ))}
                  </select>
                </div>{" "}
              </>
            )}

            {showVariants ? (
              <h4 className="ch-fs--3">Select your vehicle</h4>
            ) : null}

            {showVariants &&
              filteredVariants?.map((variant) => (
                <div key={variant.capCode}>
                  <VehicleVariantCard
                    bodyType={variant.bodyType}
                    capCode={variant.capCode}
                    carDetails={`${vehicle.manufacturer} ${capitaliseFirstLetters(variant.modelLongDescription.toLowerCase())}`}
                    engineSize={variant.engineSize}
                    handleSelectClick={handleSelectClick}
                    derivative={variant.derivativeLongDescription}
                    transmission={variant.transmission}
                    derivativeYearIntroduced={variant.derivativeYearIntroduced}
                    derivativeYearDiscontinued={variant.derivativeYearDiscontinued}
                  />
                </div>
              ))}

            <InfoModal
              buttonText="Close"
              contentStyles={{ width: "333px", height: "360px" }}
              footerText="You can often find your vehicle's full information in the owner's manual or V5 document."
              handleButtonClick={closeModal}
              headerText="About vehicle variants"
              listContent={[
                "Body type",
                "Model variant",
                "Engine size",
                "Transmission"
              ]}
              listHeaderText="In addition to the make and model, we need more specific information like:"
              mainText="Telling us more about your vehicle will help us provide an accurate quote for your car."
              showModal={showModal}
            />
          </>
        </PageLayout.Content>
      </PageLayout>
    </div>
  );
}
